/* Maison Byōbu V2 · le cadreur des créations (08/10, agent fiche ; plan C3, relecture indépendante prix et commande).
   Chargé APRÈS assets/mb-cadreur.js, et seulement sur les fiches des créations (sections/mb-cadreur.liquid, data-format) :
   les neuf œuvres japonaises ne chargent pas ce fichier, leur cadreur reste exactement le même.
   Ce fichier ne touche à aucun calcul de prix : tarifImprime, mbDevis, les remises, Apippa, les propriétés « Votre mur » et
   « Cadrage » et la taille imprimée (this.imp = mur + 10 cm) restent ceux de mb-cadreur.js.
   - panoramique : rien ne change dans le dessin ; _cadrage reçoit en plus format et image (le fichier motif pour l'atelier).
   - raccord, matiere : le mur montre la tuile (data-tuile) répétée, une tuile = data-raccord-cm sur la largeur imprimée ;
     rien à cadrer (toujours « Tout le mur », pas d'« œuvre entière ») ; limite de finesse sur la tuile, pas sur le mur ;
     _cadrage reçoit format, tuile, raccord_cm et le nombre de répétitions sur la largeur.
   Corrections après relecture (08/10, I3 à I5) :
   - l'image transmise à l'atelier est le fichier ORIGINAL (data-fichier, sans paramètre de largeur), jamais la version
     réduite affichée ;
   - raccord, matière : tuile_l_px, tuile_h_px (taille réelle du fichier), raccord_cm, raccord_type « droit »,
     origine « haut-gauche » ;
   - raccord ou matière sans tuile ou sans raccord_cm : aucun panoramique étiré, le bouton devient « Demander mon devis
     au designer » et l'ajout est bloqué (même chemin que la limite de finesse). */
(() => {
  const C = customElements.get('mb-cadreur');
  if (!C || C.prototype.mbV2) return;
  const P = C.prototype;
  P.mbV2 = true;
  const MARGE = 0; // MB_MARGE de mb-cadreur.js (0 depuis le 16/10 : plus de marge ajoutée) (marge de pose ajoutée à chaque dimension)
  const DPI_SOURCE = 25; // MB_DPI_SOURCE de mb-cadreur.js
  const r4 = (v) => Math.round(v * 10000) / 10000;
  const https = (u) => String(u || '').replace(/^\/\//, 'https://');
  const orig = {
    fondMur: P.fondMur, calculer: P.calculer, majCartes: P.majCartes, limite: P.limite, cadrage: P.cadrage, mailto: P.mailto,
  };

  /* Lecture du format, une fois par cadreur */
  P.mbV2Lire = function () {
    if (this.mbV2Pret) return;
    this.mbV2Pret = true;
    this.format = this.dataset.format || '';
    const repete = this.format === 'raccord' || this.format === 'matiere';
    const rc = parseFloat(this.dataset.raccordCm);
    this.raccord = repete && this.dataset.tuile && rc > 0 ? rc : 0;
    /* Donnée de fabrication manquante : jamais de repli (ni 76 cm, ni panoramique étiré), le designer prépare le devis */
    this.incomplet = repete && !this.raccord;
    if (this.incomplet) {
      this.dataset.repete = 'oui';
      this.dataset.incomplet = 'oui';
      this.el.mur.style.backgroundImage = 'none';
      for (const c of this.el.cartes) c.style.setProperty('--mb-carte-img', 'none');
    }
    if (this.raccord) {
      this.dataset.repete = 'oui';
      this.urlMur = `url("${this.dataset.tuile}")`;
      this.el.mur.style.backgroundImage = this.urlMur;
      for (const c of this.el.cartes) c.style.setProperty('--mb-carte-img', this.urlMur);
    }
  };

  /* Taille CSS d'une tuile : raccord cm rapportés à la largeur imprimée du mur dessiné (exemple compris) */
  P.tailleTuile = function () {
    return `${(this.raccord / (this.gL + MARGE)) * 100}% auto`;
  };

  P.fondMur = function () {
    if (this.incomplet) { this.el.mur.style.backgroundImage = 'none'; return; }
    if (!this.raccord || !this.gL) return orig.fondMur.call(this);
    const s = this.el.mur.style;
    s.backgroundImage = this.urlMur;
    const l = this.el.les.style; l.left = '0'; l.width = '100%'; l.top = '0'; l.height = ''; l.bottom = '0';
    s.backgroundRepeat = 'repeat';
    s.backgroundSize = this.tailleTuile();
    s.backgroundPosition = '0 0';
  };

  /* Tuile répétée : tout est visible, une seule carte, jamais « L'œuvre entière ». this.imp reste this.pc (mur + 10 cm). */
  P.calculer = function () {
    if (!this.raccord && !this.incomplet) return orig.calculer.call(this);
    this.rendu = 'tout'; this.bx = 0.5; this.by = 0.5;
    this.fw = 1; this.fh = 1; this.x0 = 0; this.y0 = 0;
    orig.calculer.call(this);
  };

  /* Les cartes du rendu : appelées par calculer() et majVoirChezMoi() */
  P.majCartes = function () {
    if ((this.raccord || this.incomplet) && this.pe) { this.visible = 1; this.unique = true; this.pe.ok = false; this.dataset.unique = 'oui'; }
    orig.majCartes.call(this);
    if (!this.raccord || !this.pc) return;
    const A = this.el.cartes[0];
    if (!A) return;
    if (this.dataset.etat === 'pret') A.querySelector('[data-mb-carte-ligne]').textContent = 'Le motif se répète sur tout votre mur.';
    const va = A.querySelector('.mb-carte__vignette');
    va.style.backgroundRepeat = 'repeat';
    va.style.backgroundSize = this.tailleTuile();
    va.style.backgroundPosition = '0 0';
  };

  /* Finesse : c'est la tuile qui est agrandie à raccord cm, pas l'image entière au mur */
  P.limite = function () {
    if (this.incomplet) return !!this.imp; // tuile ou raccord_cm manquant : toujours le devis, jamais l'ajout
    if (!this.raccord) return orig.limite.call(this);
    if (!this.srcL || !this.imp) return false;
    return this.srcL * 254 < DPI_SOURCE * 100 * this.raccord;
  };

  /* Contrat avec l'atelier : les champs v2 inchangés, puis le format et l'échelle (ajoutés à la fin) */
  P.cadrage = function (pourMur = false) {
    const base = JSON.parse(orig.cadrage.call(this, pourMur));
    if (!this.format) return JSON.stringify(base);
    base.format = this.format;
    const fichier = https(this.dataset.fichier); // le fichier original, pleine définition
    if (this.raccord) {
      base.x0 = 0; base.y0 = 0; base.x1 = 1; base.y1 = 1;
      base.tuile = fichier;
      base.tuile_l_px = parseInt(this.dataset.tuileLPx, 10) || null;
      base.tuile_h_px = parseInt(this.dataset.tuileHPx, 10) || null;
      base.raccord_cm = this.raccord;
      base.raccord_type = 'droit';
      base.origine = 'haut-gauche';
      base.repetitions = r4(base.largeur_cm / this.raccord);
    } else if (fichier) base.image = fichier;
    return JSON.stringify(base);
  };

  /* Données de fabrication manquantes : le message du devis le dit simplement */
  const origTexteLimite = P.texteLimite;
  P.texteLimite = function () {
    if (!this.incomplet) return origTexteLimite.call(this);
    return 'Nous préparons le fichier de ce motif pour votre mur : <a class="mb-lien" href="mailto:' + (this.dataset.mail || '') + '" data-mb-ecrire>écrivez-nous</a>. Nous vous répondons avec un devis.';
  };

  /* L'e-mail au designer : « motif répété » à la place du passage */
  P.mailto = function () {
    const url = orig.mailto.call(this);
    if (!this.raccord) return url;
    return url.replace(encodeURIComponent('l’œuvre presque entière'), encodeURIComponent(`motif répété, tuile de ${String(this.raccord).replace('.', ',')} cm`));
  };

  /* Les cadreurs déjà montés (mb-cadreur.js est passé avant nous) : on lit le format et on redessine, sans rien recalculer */
  for (const el of document.querySelectorAll('mb-cadreur[data-format]')) {
    if (!el.el) continue;
    el.mbV2Lire();
    if (el.gL && el.gH) el.geometrie(el.gL, el.gH, true);
    el.afficherPrix();
  }
})();
